export const DROP_SIDE_SAVE_MONEY = 'dropSideSaveMoney';
export const QUICK_PRODUCT_VIEW = 'quickProductView';
export const INK_MATCH_MODAL = 'inkMatchModal';
